import * as React from 'react';

import styled from 'styled-components';

interface FlagProps {
  className?: string;
  countryCode: string;
  bigFlag?: boolean;
  squareFlag?: boolean;
  rectangularFlag?: boolean;
}

const getBorderRadius = (props) => {
  if (props.squareFlag) {
    return '4px';
  } else if (props.rectangularFlag) {
    return '';
  } else {
    return '50%';
  }
};

export const Flag: React.FC<FlagProps> = (props) => (
  <span className={props.className} />
);

export default styled(Flag)`
  width: ${(props) => (props.bigFlag ? '20px' : '15px')};
  height: ${(props) => (props.bigFlag ? '20px' : '15px')};
  display: block;
  border-radius: ${(props) => getBorderRadius(props)};
  background-size: cover;
  background-color: ${({ theme }) => theme.colors.white};
  background-repeat: no-repeat;
  background-position: center center;
  background-image: ${(props) =>
    `url(${
      process.env.PUBLIC_URL
    }/static/flags/${props.countryCode?.toUpperCase()}.svg);`};

  @media ${({ theme }) => theme.device.tablet} {
    width: ${(props) => (props.bigFlag ? '28px' : '15px')};
    height: ${(props) => (props.bigFlag ? '28px' : '15px')};
  }
`;
